export default "__VITE_ASSET__8b77284c__"